import { AuthBindings } from "@refinedev/core";
import { AxiosInstance } from "axios";

import CONFIG from "app-config/config.json";
import { axiosInstance } from "providerrs/axiosInstance";
import toast from "react-hot-toast";
import { IUserData, UserType } from "interfaces";
import { getWorkspaceAuthDomain } from "utills/authDomain";

const API_URL = CONFIG.API;
const API_WORKSPACE_URL = CONFIG.WORKSPACE_API;
const AUTH_TOKEN = CONFIG.AUTH_TOKEN;

const provider = (axiosInstance: AxiosInstance): AuthBindings => {
  return {
    login: async (user: { email: string; password: string, type: string }) => {

      try {
        if (user?.type && user?.type === 'wps') {
          const domain = getWorkspaceAuthDomain();

          const { data } = await axiosInstance.post(`${API_WORKSPACE_URL}/api/auth/login`, {
            email: user.email,
            password: user.password,
            domain
          });

          const result = data.data;

          result['type'] = 'wps';

          let permission = false;
          localStorage.setItem('USER', JSON.stringify(result));
          localStorage.setItem("access-token", result?.token);

          if (result && result.permissions && result.permissions.length > 0) {
            result.permissions.forEach((item: any) => {
              if (item.app === "dashboard") {
                permission = true;
              }
            });
          }

          return {
            success: true,
            redirectTo: permission ? "/dashboard/overview" : '/profile',
          };
        } else {
          const { data } = await axiosInstance.post(
            `${API_URL}/auth/login`,
            {
              email: user.email,
              password: user.password,
            },
            {
              headers: {
                Authorization: `Bearer ${AUTH_TOKEN}`,
              },
            }
          );
          const { email, full_name, avatar, token, permissions } = data.data.data;
          let userData: IUserData = {
            email: email,
            name: full_name,
            avatar: avatar,
            token: token,
            type: UserType.ADMIN,
            permissions: permissions
          };
          localStorage.setItem("USER", JSON.stringify({
            email: userData.email,
            name: userData.name,
            avatar: userData.avatar,
            type: userData.type,
            permissions: userData.permissions
          }));
          localStorage.setItem("access-token", userData.token);
          return {
            success: true,
            redirectTo: "/",
          };
        }
      } catch (error: any) {
        return {
          success: false,
          error,
        };
      }
    },
    forgotPassword: async ({ email, type }) => {
      try {
        console.log('type', type);
        if (type && type === 'wps') {
          const domain = getWorkspaceAuthDomain();

          const submitData = {
            email: email,
            domain
          };

          const { data } = await axiosInstance.post(
            `${API_WORKSPACE_URL}/api/auth/password/forgot`,
            submitData
          );

          return {
            success: true,
            data
          };
        } else {
          const { data } = await axiosInstance.post(
            `${API_URL}/auth/password/forgot`,
            {
              email,
            },
            {
              headers: {
                Authorization: `Bearer ${AUTH_TOKEN}`,
              },
            }
          );
          return {
            success: true,
            data
          };
        }

      } catch (error: any) {
        return {
          success: false,
          error,
        };
      }
    },
    updatePassword: async ({ password, confirmPassword, token, user_id, type }) => {
      try {
        if (type && type === 'wps') {
          const submitData = {
            token: token,
            password: password
          };

          await axiosInstance.put(
            `${API_WORKSPACE_URL}/api/auth/${user_id}/password/reset`,
            submitData
          );

          return {
            success: true,
            redirectTo: "/login",
          };
        } else {
          const { data } = await axiosInstance.put(
            `${API_URL}/auth/${user_id}/password/reset`,
            {
              password,
              token,
            },
            {
              headers: {
                Authorization: `Bearer ${AUTH_TOKEN}`,
              },
            }
          );
          toast.success(`Your password has been reset successfully`, {
            duration: 6000,
            position: "top-center"
          })

          return {
            success: true,
            redirectTo: "/login",
          };
        }
      } catch (error: any) {
        return {
          success: false,
          error,
        };
      }
    },
    logout: async (props) => {
      localStorage.removeItem("USER");
      localStorage.removeItem("access-token");
      localStorage.removeItem("currency");
      return {
        success: true,
        redirectTo: props?.redirectPath || "/login",
      };
    },
    onError: async (error: any) => {
      if (error?.response?.status === 401) {
        return {
          logout: true,
          redirectTo: "/login",
          error,
        };
      }

      return {};
    },
    check: async () => {
      const token = localStorage.getItem("USER");
      const currency = localStorage.getItem("currency");
      if (!currency) {
        localStorage.setItem("currency", "VND");
      }
      if (!token) {
        return {
          authenticated: false,
          error: new Error("No token found"),
          redirectTo: "/login",
        };
      }
      return {
        authenticated: true,
      };
    },
    getPermissions: async () => null,
    getIdentity: async () => {
      const user = localStorage.getItem("USER");
      if (!user) {
        return null;
      }
      return JSON.parse(user);
      // try {
      //   const userInfo = await axiosInstance.get(`${API_URL}/user`);
      //   return userInfo.data.user;
      // } catch (error) {
      //   console.warn(error);
      //   return null;
      // }
    },
  };
};

export const authProvider = provider(axiosInstance);
